import React from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';
import { Add } from '@material-ui/icons';

const useStyle = makeStyles<Theme, IStyleProps>((theme) => ({
  input: {
    display: 'none',
  },
  addIcon: {
    position: 'absolute',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '50%',
    border: `1px solid ${theme.palette.secondary.light}`,
    top: '80%',
    left: '70%',
  },
  thumbnail: {
    backgroundImage: ({ imgUrl }) => `url('${imgUrl}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    width: '125px',
    height: '125px',
  },
}));
interface IProps {
  imgUrl: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
interface IStyleProps {
  imgUrl: string;
}
const AvatarEditor: React.FC<IProps> = ({ imgUrl, onChange }) => {
  imgUrl = imgUrl !== '' ? imgUrl : '/images/placeholder.png';
  const { thumbnail, addIcon, input } = useStyle({ imgUrl });

  return (
    <Box my={2}>
      <input
        accept='image/*'
        id='contained-button-file'
        className={input}
        type='file'
        onChange={onChange}
      />
      <label htmlFor='contained-button-file'>
        <Box
          display='flex'
          position='relative'
          justifyContent='center'
          alignItems='center'
        >
          <div className={thumbnail} />
          <Add color='secondary' className={addIcon} fontSize='default' />
        </Box>
      </label>
    </Box>
  );
};

export default AvatarEditor;
